import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 23,
  label: "省市年度授权量分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "applicantProvince", label: "省", needTotal: true }],
    colDims: [{ name: "authDate", label: "授权年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    condition: {
      items: [{
        name: "applicantProvince",
        operator: "NOT_NULL"
      }, {
        name: "authDate",
        operator: "NOT_NULL"
      }]
    },
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "省市年度授权量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false
  }
};
